import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ExpWithPicLeft from "../../ExpWithPicLeft";
import ExpWithPicRight from "../../ExpWithPicRight";

import ScienceTwoToneIcon from "@mui/icons-material/ScienceTwoTone";
import SanitizerTwoToneIcon from "@mui/icons-material/SanitizerTwoTone";
import CleanHandsTwoToneIcon from "@mui/icons-material/CleanHandsTwoTone";
import { makeStyles } from "@mui/styles";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import HealthAndSafetyTwoToneIcon from "@mui/icons-material/HealthAndSafetyTwoTone";
import CardComp from "../Card";
import WbIridescentTwoToneIcon from "@mui/icons-material/WbIridescentTwoTone";
import ErrorIcon from "@mui/icons-material/Error";

import Reveal from "react-reveal/Reveal";

import AddTaskIcon from "@mui/icons-material/AddTask";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "30px",
    paddingTop: 20,
    paddingBottom: 100,
    textAlign: "center",
    lineHeight: "1.6em",
    // fontWeight: "bold",
  },
  icons: {
    maxWidth: "750px",
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "50px",
    paddingBottom: "50px",
  },
  iconboxwrapper: {
    // border: "1px solid black",
    justifyContent: "center",
    alignItems: "center",
  },
  iconbox: {
    padding: "10px",
    borderRadius: "50%",
    // border: "3px solid #f5f5f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "150px",
    height: "150px",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const BioCandle = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {/* <Box sx={{ textAlign: "center", py: 5 }}>
				<Box sx={{ fontSize: "32px", zIndex: 1000, lineHeight: "140%" }}>
					Simply
					<br /> <span style={{ fontSize: "70px" }}>Natural</span>
					<Box sx={{ fontSize: "14px", color: "gray" }}>
						100% natural phytoncide oil from cypress tree
					</Box>
				</Box>
				<img src="/img/6166906.jpg" width="700" alt="" />
			</Box> */}
      {/* <Box sx={{ width: 3 / 4 }}>
        <Reveal bottom>
          <Box>
            <Box
              className="textTitle"
              sx={{
                textAlign: "left",
                pb: 2,
                pt: 10,
              }}
            >
              It is our New Technology
            </Box>
            <Box
              sx={{
                fontSize: "20px",
                lineHeight: "1.5em",
                fontWeight: 400,
                pt: 2,
              }}
            >
              With our Materials Technology (Anti-Bacterial, Incombustible,
              etc.), We make differences.
            </Box>
          </Box>
        </Reveal>
        <Box>
          <Grid
            container
            sx={{
              display: "flex",
              pt: 5,
              pb: 20,
              justifyContent: "space-between",
            }}
          >
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<ScienceTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="100% Non-Alchohol Sanitizing"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_trd032tg06637.jpg"
                content2="We extract cleansing ingredients from natural tangerlines."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<CleanHandsTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="99.9% Strong Sanitizing"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_tip014d20040071.jpg"
                content2="Only with one sheet of our wipe, kill 99.9% harmful bacteria and viruses."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<SanitizerTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="99.9% Sanitizing for 7 days"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_ti219a20203.jpg"
                content2="Sanitizing will not be disappear for 168 hours."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<ContentCopyTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="100% Biogradable Rayon"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_trd022tg31669.jpg"
                content2="Our wipes are made with Non-woven and biogradable fabric."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<WbIridescentTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="Natural Scents"
                content="We made our wipes without any artificial scent for your health."
                link=""
                image="/img/CK_tc01090000083.jpg"
                content2="We put 100% natural genuine phytoncide from trees."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<HealthAndSafetyTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="Safe for your skin"
                content="Our wipes are made with all natural ingredients. It is safe for your skin."
                link=""
                image="/img/CK_ti436a12007.jpg"
                content2="Gold Colloid for skin health and moisturization."
              />
            </Grid>
          </Grid>
        </Box>
      </Box> */}
      <Box
        sx={{
          width: { md: 3 / 4, sm: 1 },
          pb: 10,
          pt: 5,
        }}
      >
        <Reveal bottom>
          <Box sx={{ pb: 10, px: { md: 0, sm: 5, xs: 5 } }}>
            <Box sx={{ fontSize: "20px", lineHeight: "130%", pb: 3 }}>
              Principle of Anions' Air Purification
              <br />- Indoor Air Pollutants
            </Box>

            <Grid container>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: { md: 0, sm: 5, xs: 5 },
                }}
              >
                <img
                  src="/img/pollutants.png"
                  alt="pollutants"
                  width="400"
                  style={{
                    height: "auto",
                  }}
                />
              </Grid>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: { md: 0, sm: 5, xs: 5 },
                }}
              >
                <img
                  alt="smoke"
                  height="380"
                  style={{
                    position: "relative",
                    objectFit: "cover",
                    width: "500px",
                  }}
                  src="https://images.unsplash.com/photo-1616943412395-5ecf65f437d1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ pb: 10, px: { md: 0, sm: 5, xs: 5 }, pt: 10 }}>
            <Grid container>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: { md: 0, sm: 5, xs: 5 },
                }}
              >
                <img
                  src="/img/Bio-Candle-image.png"
                  alt="pollutants"
                  width="370"
                  style={{
                    height: "auto",
                  }}
                />
              </Grid>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: { md: 0, sm: 5, xs: 5 },
                  flexDirection: "column",
                }}
              >
                <Box sx={{ pt: 4, pb: 7 }}>
                  The anion released from the HESLET BIO candle{" "}
                  <span className="pink_link">
                    quickly and strongly adsorbs and neutralizes various fine
                    particles
                  </span>{" "}
                  that pollute the room.
                </Box>
                <img src="/img/anions.png" style={{ width: "100%" }} />
              </Grid>
            </Grid>
          </Box>
        </Reveal>
      </Box>
      <Box sx={{ pb: 10, px: { md: 0, sm: 5, xs: 5 }, lineHeight: "130%" }}>
        <Box sx={{ fontSize: "20px", lineHeight: "170%", pb: 3 }}>
          HESLET Bio Candle emits higher levels of anions than a mountain. It
          helps you enjoy indoor life healthier.
        </Box>

        <Grid container>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { md: 0, sm: 5, xs: 5 },
            }}
          >
            <img
              src="/img/anion-graph.png"
              alt="pollutants"
              width="400"
              style={{
                height: "auto",
              }}
            />
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { md: 0, sm: 5, xs: 5 },
            }}
          >
            <img
              alt="smoke"
              height="380"
              style={{
                position: "relative",
                objectFit: "cover",
                width: "500px",
              }}
              src="/img/anion-effect.jpg"
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ width: 3 / 4, py: 10 }}>
        <Reveal bottom>
          <Box sx={{ fontSize: "20px" }}>The Effect of Far-Infrared Rays</Box>
          <Box sx={{ fontSize: "17px", pt: 2, lineHeight: "1.9em" }}>
            1. Disinfecting Effect
            <br />
            2. Boost Blood Circulation <br />
            3. Improve Immune System
            <br />
            The far-infrared wave length of the HESLET Bio Candle is similar to
            that of loess.
          </Box>
          <Box
            sx={{
              pt: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src="/img/Bio-Candle3.png" style={{ width: "100%" }} alt="" />
          </Box>
        </Reveal>
      </Box>
      <Box sx={{ width: 3 / 4, py: 10, pb: 20 }}>
        <Reveal bottom>
          <Box sx={{ fontSize: "20px" }}>3 Types of Scents</Box>
          <Box sx={{ pt: 2 }}>
            - All purpose wipe is tough enough to fight with almost any mess.
            See the differences.
          </Box>
          <Grid container sx={{ display: "flex", pt: 5 }}>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                px: 2,
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1602615576820-ea14cf3e476a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                alt="before"
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  paddingTop: "10px",
                }}
              />
              <Box sx={{ pt: 2 }}>
                <Box>La noblesse</Box>
                <Box sx={{ pt: 2 }}>
                  The scent of real flowers that you can smell as soon as
                  stepping inside a flower shop <br />
                  Fragrance Blend - <br />
                  Lime, Basil, Geranium
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                px: 2,
                pt: { md: 0, xs: 5, sm: 5 },
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1494825514961-674db1ac2700?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                alt="before"
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  paddingTop: "10px",
                }}
              />
              <Box sx={{ pt: 2 }}>
                <Box>Forest</Box>
                <Box sx={{ pt: 2 }}>
                  The scent of dense forest
                  <br />
                  Fragrance Blend - <br />
                  Eucalyptus, Lemon Grass, Lime, and Pasley
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                px: 2,
                pt: { md: 0, xs: 5, sm: 5 },
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1593204075264-0b7994458bf3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                alt="before"
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  paddingTop: "10px",
                }}
              />
              <Box sx={{ pt: 2 }}>
                <Box>Recovery</Box>
                <Box sx={{ pt: 2 }}>
                  The scent of the tranquil morning forest <br />
                  Fragrance Blend - <br />
                  Agilawood, En passant
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Reveal>
      </Box>
    </Box>
  );
};

export default BioCandle;
